export default {
  watch: {
    $route(to, from) {
      if(this.getFirstPath(to) != this.getFirstPath(from)) {
        this.$emit('refresh')
      }
    }
  }
}